module.exports = __webpack_public_path__ + "img/chanceofsleet.dfa6fec2.png";